import styled from '@emotion/styled'

export const CenteredWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
`
